import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'
import { AxiosPromise } from 'axios'
import { ResponseData } from 'request'

export enum StatusType {
  WaitSend = 'wait_send',
  Send = 'send',
  Cancel = 'cancel',
  Revoke = 'revoke',
  Draft = 'draft',
  Active = 'active',
  Stop = 'stop',
}

export enum MeaasgeStatusType {
  Send = 'send', // 未读
  Read = 'read', // 已读
}
export interface ListQuery {
  created_start_time?: string
  created_end_time?: string
  send_start_time?: string
  send_end_time?: string
  sender_id?: number
  status?: StatusType
  title?: string
  page?: number
  page_size?: number
}

export interface AdvListQuery {
  adv_ids?: number[]
  grant_type?: number
  permissions?: string[]
  plan_ids?: number[]
  custom?: number
  status?: string
  need_all?: number
  page: number
  page_size: number
}

export interface MessageLangs {
  content: string
  lang: string
  msg_id: number
  title: string
}

export interface ListMessage {
  created_time: string
  msg_id: number
  read_count: number
  send_count: number
  send_time: number
  sender_name: string
  status: string
  message_langs: MessageLangs[]
  is_pop_up: number
  trigger: string
  trigger_value: string
  type: string
}

export interface AdvListMessage {
  adv_id: number
  adv_name: string
}

/**
 * 站内信options管理
 * @param {*} params
 */
export function getMessageOptions(params: { option_type: string }) {
  return request({
    url: `${v2Host}/message/options`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * 站内信管理列表
 * @param {*} params
 */
export function messageList(
  params: ListQuery,
): AxiosPromise<ResponseData<ListMessage>> {
  return request({
    url: `${v2Host}/message/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * 站内信广告主筛选
 * @param {*} params
 */
export function messageAdvList(
  params?: AdvListQuery,
): AxiosPromise<ResponseData<AdvListMessage>> {
  return request({
    url: `${v2Host}/message/adv-list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * 站内信创建发送
 * @param {*} data
 */
export function messageSave(data: any) {
  return request({
    url: `${v2Host}/message/save`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  })
}

/**
 * 站内信操作
 * @param {*} data
 */
export function messageUpdate(data: { command: StatusType; msg_id: number }) {
  return request({
    url: `${v2Host}/message/update`,
    method: 'post',
    data,
  })
}

/**
 * 站内信消息读取状态记录
 * @param {*} params
 */
export function messageStatusRecord(params: {
  page: number
  page_size: number
  msg_id: number
  status: MeaasgeStatusType
  all_users?: boolean
}) {
  return request({
    url: `${v2Host}/message/status-record`,
    method: 'get',
    params,
  })
}

/**
 * 获取草稿
 */
export function messageDraft() {
  return request({
    url: `${v2Host}/message/draft`,
    method: 'get',
  })
}

/**
 * 站内信详情
 * @param {*} msg_id
 */
export function messageDetail(msg_id: number) {
  return request({
    url: `${v2Host}/message/detail`,
    method: 'get',
    params: {
      msg_id,
    },
  })
}
